import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button, Dialog, DialogContent,
    DialogActions, makeStyles,
} from '@material-ui/core';
import StringUtils from 'lib/StringUtils';
import ButtonStyles from 'styles/theme/Button';
import TextField from '@material-ui/core/TextField';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme));
const useStyles = makeStyles((theme) => ({
    AppBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
        },
    },
    dialogContent: {
        padding: '10px 0',
    },
}));

const CloneEntityDialog = ({
    isRuleEntity,
    entity,
    isSavingEntity,
    onClose,
    onSaveEntity,
}) => {
    const classes = { ...useStyles(), ...buttonStyles() };
    const [label, setLabel] = useState(entity.label);

    const areEqual = label?.trim() === entity.label.trim();
    const saveRule = () => {
        if (areEqual) return;

        onSaveEntity(isRuleEntity ? {
            categoryId: entity.category.id,
            label,
            query: entity.query,
            instructions: entity.instructions,
        } : {
            categoryId: entity.category.id,
            label,
            query: entity.query,
            type: entity.type,
            options: entity.options,
            customReport: entity.customReport,
        });

        setLabel('');
        onClose();
    };

    return (
        <Dialog
            open
            fullWidth
            maxWidth="sm"
            disableBackdropClick
            disableEscapeKeyDown
            scroll="paper"
            onMouseDown={(e) => e.stopPropagation()}
        >
            <DialogAppBar
                appBarClassName={classes.AppBar}
                title={isRuleEntity ? 'Duplicate Rule' : 'Duplicate Chart'}
                onClose={onClose}
                toolbarSize="md"
            />
            <DialogContent>
                <div className={classes.dialogContent}>
                    <TextField
                        autoFocus
                        label="Label (160 Characters Max)"
                        variant="outlined"
                        value={label}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setLabel(e.target.value)}
                        margin="dense"
                        fullWidth
                        inputProps={{ maxLength: 160 }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className={classes.containedSecondaryInfo}
                    disabled={
                        StringUtils.isEmpty(label)
                        || areEqual
                        || isSavingEntity
                    }
                    onClick={saveRule}
                >
                    Save
                </Button>
                <Button
                    disabled={isSavingEntity}
                    className={classes.containedError}
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

CloneEntityDialog.propTypes = {
    isRuleEntity: PropTypes.bool.isRequired,
    entity: PropTypes.object.isRequired,
    isSavingEntity: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSaveEntity: PropTypes.func.isRequired,
};

export default CloneEntityDialog;
